// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperImages-cls1_OMs","cls2":"PaperImages-cls2_itf PaperImages-cls1_OMs"};